
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shallwesleep",
      function () {
        return require("private-next-pages/shallwesleep/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shallwesleep"])
      });
    }
  